// Bicycle API 환경 설정

// 개발/운영 환경 판단
export const isDevelopment = process.env.NODE_ENV === 'development';

// API Base URL 설정 - 환경변수 우선, 없으면 기본값 사용
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 
  (isDevelopment 
    ? 'https://test.urcode.me' 
    : 'https://api.urcode.me');

// API 버전
export const API_VERSION = '/api/v1';

// API 타임아웃 설정 (ms)
export const API_TIMEOUT = 30000;

// Bicycle 관련 API 엔드포인트
export const BICYCLE_API_ENDPOINTS = {
  // 소유자 관련
  OWNER: {
    GET_ID: `${API_VERSION}/temp/owner`,
    CHECK_OWNERSHIP: (urcode: string) => `${API_VERSION}/temp/check/owner/${urcode}`,
    REGISTER: `${API_VERSION}/temp/register/owner`,
    GET_LIST: (ownerId: string) => `${API_VERSION}/temp/owner/list/${ownerId}`,
    DELETE_ITEM: (ownerId: string, urcode?: string) => {
      if (urcode) {
        return `${API_VERSION}/temp/owner/items/delete/${ownerId}?ur=${urcode}`;
      }
      // 전체 삭제는 ur=clear로 수정
      return `${API_VERSION}/temp/owner/items/delete/${ownerId}?ur=clear`;
    }
  },
  // 관리자 관련
  ADMIN: {
    GET_ALL_OWNERS: `${API_VERSION}/temp/admin/owners`
  }
};

// 현재 사용 중인 API URL 로그 (개발 환경에서만)
if (isDevelopment) {
  console.log('Current API Base URL:', API_BASE_URL);
  console.log('Environment:', process.env.NODE_ENV);
  console.log('REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);
}
